import React, {useState, useEffect} from 'react'
import { AiOutlineCloseCircle } from 'react-icons/ai'
import { BsFillCaretDownFill, BsCaretRightFill } from 'react-icons/bs'
import { MdDeleteOutline } from 'react-icons/md'
import Singleselect from '../Singleselect/Singleselectt'
import './forwardnotice.css'
import KPIListjson from './kpilist'
import Membersjson from './members'
let commentsArray = []
let checker = 0

const ForwardNotice = ({sendnotice}) => {
    const [members, setMembers] = useState(false)
    const [dealss, setDealss] = useState([])          // Arrays of Objects holding durrent deals {key: 1, dels: Tour}
    const [kpilist, setKpilist] = useState([])
    const [caret,setCaret] = useState(true)
    const [caret2,setCaret2] = useState(true)
    const [kpi, setKpi] = useState(false)
    const [rowcount, setRowcount] = useState(0);
    const [shown1, setShown1] = useState(true)
    const [shown2, setShown2] = useState(true)
    const [fields, setFields] = useState({
        appraised: '',
        assignedkpi: [],
        notappraised: []
    })
    const [kpis, setKpis] = useState([])

    useEffect(() => {
        setFields({...fields, notappraised: dealss})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rowcount])

    useEffect(() => {
        setFields({...fields, assignedkpi: kpis})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checker])

    const handleClose = () =>{
        sendnotice("close")
    }

    const handleBroadcast = () =>{
        // Post Data to server
        // console.log(fields)
    }

    const handleDealsFocus = () =>{
        setMembers(!members)
    }

    const handleDealFocus = () =>{
        setKpi(!kpi)
    }

    // Onclick of element close button remove item from array list
    const handleClosedealItem = (e, incoming) =>{
        setRowcount(rowcount - 1)  
        setDealss(dealss.filter((filteredeals)=>(filteredeals.key !== incoming.itemid)))
        // console.log(incoming.itemid)
        setFields({...fields, notappraised: dealss})
    }

    // Onclick of element close button remove item from array list
    const handleClosekpiItem = (e, incoming) =>{
        setKpilist(kpilist.filter((filteredeals)=>(filteredeals.key !== incoming.itemid)))
        setKpis(kpis.filter((filterkpi, index)=>((index+1) !== incoming.itemid)))
        setFields({...fields, assignedkpi: kpis.filter((filterkpi, index)=>(index+1 !== incoming.itemid))})
        checker = kpis.length
    }

    const handleDealsClick = (e, incoming) =>{
        // check If the item to be added already exists. if it already exist returns True (Then Remove the Item), else False(Add the Item)
        setRowcount(rowcount + 1)
        if(dealss.some((exitstingItem) => exitstingItem.key === incoming.key) === false){
          const updateMonths = [
            ...dealss,
            incoming
          ];
          setDealss([...updateMonths])
        } else{
          setDealss(dealss.filter((filteredeals)=>(filteredeals.key !== incoming.key)))
          setRowcount(rowcount - 1)
        }
        setFields({...fields, notappraised: dealss})
        setMembers(false)
    }

    const handleKpiClick = (e, incoming) =>{
        // check If the item to be added already exists. if it already exist returns True (Then Remove the Item), else False(Add the Item)
        if(kpilist.some((exitstingItem) => exitstingItem.key === incoming.key) === false){
          const updateMonths = [
            ...kpilist,
            incoming
          ];
          setKpilist([...updateMonths])
        //   fields.assignedkpi.push(incoming.dels)
          kpis.push(incoming.dels)
        }
        checker = kpis.length
        setKpi(false)
    }

    const handleselectedSocVal = (incomingval) =>{
        setFields({ ...fields, appraised: incomingval});
    }

    const handleshownapp = () =>{
        setShown1(!shown1)
        setCaret(!caret)
    }

    const handleshownotapp = () =>{
        setShown2(!shown2)
        setCaret2(!caret2)
    }

    const handleInputChange = (event, index) =>{
        const {name, value} = event.target
        const obj = {
            ...dealss[index], 
            [name]: value
        }

        const objWithIdIndex = dealss.findIndex((membobj) => membobj.key === obj.key);
        // if object doesnt exist it returns -1 else it retr=urns the index of the object
        if (objWithIdIndex > -1) {
            // if object exists, then replace it with new object
            dealss.splice(objWithIdIndex, 1, obj);
        } else{
            // if object doesnt exist then PUSH the Object into the array
            fields.notappraised.push(obj)
        }

        setFields({...fields, notappraised: dealss})
    }

  return (
    <div className='overlay-container'>
            <div className='overlay-reals-container'>
                <div className='top-container-apprais-notif'>
                    <span>FORWARD APPRAISAL NOTIFICATION</span>
                    <AiOutlineCloseCircle id='closeIcon-notifc' onClick={handleClose}/>
                </div>

                <div className='top-appraisal-conta-body'>
                <div className='top-appraisal-conta-body-mid'>
                    <div className='top-members-appraisal' onClick={handleshownapp}>
                        Team Member to be appraised
                        {caret ? <BsFillCaretDownFill/> :
                        <BsCaretRightFill />}
                    </div>

                    {shown1 && <div className='top-members-appraisal-body'>
                        <Singleselect selectedSocVal={handleselectedSocVal} socialjs={Membersjson} placeholder="Select member..."/>
                        
                        <span id='select-appraisal-title'>Select Appraisal KPI (6 max)</span>
                        <div id='agencynames'>
                            {kpilist.map((item, index) => {return(<span id='deals-result' key={item.key}>{item.dels} <MdDeleteOutline id='close-deals' onClick={e => handleClosekpiItem(e, {itemid: item.key})}/></span>)})}

                            {kpi && <div className='bnw-deals-drpdwn'>{KPIListjson.map((item, key) => (
                                <span onClick={e => handleKpiClick(e, {key: item.id, dels: item.value})} key={key}>{item.value}</span>
                            ))}
                            </div>}

                            <BsFillCaretDownFill id='caret-down-select' onClick={handleDealFocus}/>
                        </div>
                    </div>}

                    <div className='top-members-appraisal' onClick={handleshownotapp}>
                        Team Members You don't want to be appraised
                        {caret2 ? <BsCaretRightFill /> : <BsFillCaretDownFill/>}
                    </div>

                    {shown2 === false ? <> <div id='agencynames'>
                        {dealss.map((item, index) => {return(<span id='deals-result' key={index}>{item.dels} <MdDeleteOutline id='close-deals' onClick={e => handleClosedealItem(e, {itemid: item.key})}/></span>)})}

                        {members && <div className='bnw-deals-drpdwn'>{Membersjson.map((item, key) => (
                            <span onClick={e => handleDealsClick(e, {key: item.id, dels: item.value, comment: ''})} key={key}>{item.value}</span>
                        ))}
                        </div>}

                        <BsFillCaretDownFill id='caret-down-select' onClick={handleDealsFocus}/>
                    </div> 

                    <div id='reasons-comment'>
                        {[...Array(rowcount)].map((element, index) => {
                            return (
                                <input key={index} placeholder='state comment' className='comment-txtbox' name="comment" onChange={e => handleInputChange(e, index)} id="namefield-tab"/>
                        )})}
                    </div> </> : ""}
                </div>
                    
                    <div className='top-appraisal-submit-row'>
                        <button id='broadcast-buttn' onClick={handleBroadcast}>FORWARD NOTICE</button>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default ForwardNotice